<script setup lang="ts"></script>

<template>
    <NuxtLayout name="base">
        <template #default>
            <slot />
        </template>
        <template #sidebar>
            <div></div>
        </template>
        <template #module-sidebar>
            <div></div>
        </template>
    </NuxtLayout>
</template>
